module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Regular.97fb048a.woff";